module.exports = __webpack_public_path__ + "static/media/logo-gd-wody.587b611d.png";